/** Configuración de la app. Todo lo sensible entra por variables de entorno. */

/**
 * Key de Stadia Maps.
 *
 * IMPORTANTE: Stadia autoriza el satélite POR DOMINIO, no por esta key. Tener la
 * key no habilita nada si el dominio de despliegue no está registrado en la
 * cuenta de stadiamaps.com. Además, un dominio no autorizado responde 401 con un
 * PNG válido, así que la capa "carga" y el mapa se llena de teselas de error sin
 * que nada dispare `error`. Ver `probeTileProvider` en src/map/basemaps.js y
 * docs/hallazgos.md.
 */
export const STADIA_API_KEY = import.meta.env?.VITE_STADIA_API_KEY || '';

export const DEFAULT_BASEMAP = import.meta.env?.VITE_DEFAULT_BASEMAP || 'esri';

/** Vista inicial del mapa: Pudahuel, Región Metropolitana. */
export const DEFAULT_CENTER = [-33.408639, -70.849947];
export const DEFAULT_ZOOM = 16;

/** Radio de cobertura por DEA, en metros. Referencia del Art. 5º del D.S. 56/2020. */
export const DEFAULT_RADIUS_M = 150;

/**
 * Debounce del buscador de direcciones, en milisegundos.
 *
 * Nominatim publica un límite de 1 request por segundo. Bajar esto por debajo de
 * 1000 ms genera throttling y el buscador empieza a responder "sin conexión"
 * cuando el servicio está perfectamente sano. Ya pasó una vez en producción.
 */
export const GEOCODER_DEBOUNCE_MS = 1000;

/** Escalado del canvas de exportación. 2 = doble densidad para impresión. */
export const EXPORT_SCALE = 2;

/** Claves de almacenamiento local. Versionadas para poder migrar sin pisar datos viejos. */
export const STORAGE_KEYS = {
  library: 'vh_proyectos_v1',
  autosave: 'vh_cobertura_auto',
};

export const AUTOSAVE_DELAY_MS = 800;
